module.exports = __webpack_public_path__ + "static/media/ebilling-picturemark-l.89d55eb3.svg";